import { ParticipationStatus } from '@app/api';
import { IconChip } from '@app/core';
import React from 'react';
import { Colors } from '@app/theme';
import { t } from 'i18next';

export const ParticipationStatusChip = ({
  status,
}: {
  status: ParticipationStatus;
}) => {
  type ConfigHeader = {
    [key: string]: {
      label: string;
      color: Colors;
      status: ParticipationStatus[];
    };
  };

  const configHeader: ConfigHeader = {
    confirmed: {
      label: t('studies.header.confirmed'),
      color: 'green',
      status: [ParticipationStatus.ACCEPTED, ParticipationStatus.BOOKED],
    },
    started: {
      label: t('studies.header.started'),
      color: 'green',
      status: [ParticipationStatus.IN_PROGRESS],
    },
    completed: {
      label: t('studies.header.past'),
      color: 'purple',
      status: [
        ParticipationStatus.PARTICIPATED,
        ParticipationStatus.PROCESSING_PAYMENT,
        ParticipationStatus.PAYMENT_REQUESTED,
        ParticipationStatus.PAYED,
      ],
    },
  };

  return (
    <>
      {Object.keys(configHeader).map((key) => {
        if (configHeader[key].status.includes(status)) {
          return (
            <IconChip
              key={key}
              label={configHeader[key].label.toUpperCase()}
              color={configHeader[key].color}
            />
          );
        }
        return null;
      })}
    </>
  );
};
